import React from 'react';

interface NavIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  'aria-label': string; // Ensure aria-label is required
}

export const NavIconButton: React.FC<NavIconButtonProps> = ({ icon, className = '', ...props }) => {
  return (
    <button
      type="button"
      className={[
        'w-11 h-11',
        'flex items-center justify-center',
        'rounded-full',
        'text-black-950', // Default icon color (rgba(0, 0, 0, 0.95))
        'border border-transparent', // Start with transparent border
        'shadow-lg', // Add box shadow to match Figma (0px 2px 4px 0px rgba(0, 0, 0, 0.12), 0px 0px 10px 0px rgba(0, 0, 0, 0.12))
        'hover:bg-[#CDDEEE]', // Hover background color from Figma
        'hover:border-[#0054A4]', // Hover border color from Figma
        'hover:text-[#2A73B8]', // Hover icon color from Figma
        'active:bg-[#B1CAE4]', // Pressed background color from Figma
        'active:text-[#00478B]', // Pressed icon color from Figma
        'active:border-transparent', // No border on pressed state
        'transition-colors',
        'focus:outline-none',
        'focus:ring-2',
        'focus:ring-offset-2',
        'focus:ring-[#0054A4]/50', // Adjusted focus ring to match Figma color theme
        className,
      ]
        .join(' ')
        .trim()}
      {...props}
    >
      {icon}
    </button>
  );
};

export default NavIconButton;
